import React from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component'; // Corrected import for ContentColumn
import ContactInfo from '@/components/ContactInfo/ContactInfo.component';

import { IProps } from '@/blocks/ContactInfoBlock/ContactInfoBlock.interface';
import '@/blocks/ContactInfoBlock/ContactInfoBlock.styles.css';

const ContactInfoBlock: React.FC<IProps> = ({
    items,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('contactInfoBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn className="contactInfoBlock__content">
                    {items &&
                        items.map((item, index) => (
                            // Removed layout="1/4" as it's not a valid prop for ContentColumn based on provided interfaces.
                            // ContentWrapper will handle flex/grid arrangement.
                            // If specific column sizing like 1/4 is strictly needed, ContentColumn or its styles might need adjustment.
                            <ContactInfo
                                key={`contaact-info-item-${index}`}
                                {...item}
                                className="contactInfoBlock__item"
                            />
                        ))}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default ContactInfoBlock;
